// src/environments/production.ts
import environment from "./base";
const baseApi = "//www.dreamchimney.com";
const baseApiLambda = "https://31hlhgppde.execute-api.us-west-2.amazonaws.com/dev";
const env = environment(baseApi, baseApiLambda);
export default {
  ...env
};
